import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import { ProtectedRoute } from '../../shared/auth';

import { Orders } from './orders';

function ordersRoute(routeProps: RouteComponentProps) {
  return (
    <Route
      path={`${routeProps.match.path}/orders`}
      render={(routeProps) => (
        <>
          <ProtectedRoute path={routeProps.match.url} exact>
            <Orders />
          </ProtectedRoute>
        </>
      )}
    />
  );
}

export { ordersRoute };
